import Vue from 'vue'
import VueRouter from 'vue-router'
import Landing from '../views/Landing.vue'
import AuthCallback from '../views/AuthCallback.vue'
import ElevationAPI from '../views/ElevationAPI.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import ElevationTokens from '../views/ElevationTokens.vue'
import ElevationUsage from '../views/ElevationUsage.vue'
import ElevationOruxMaps from '../views/ElevationOruxMaps.vue'
import ElevationStats from '../views/ElevationStats.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'landing',
        component: Landing,
    },
    {
        path: '/authcb/:auth',
        component: AuthCallback,
    },
    {
        path: '/elevation_api',
        name: 'elevation_api',
        component: ElevationAPI,
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        props: true,
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        children: [
            {
                path: 'elevation_tokens',
                name: 'elevation_tokens',
                component: ElevationTokens,
            },
            {
                path: 'elevation_usage',
                name: 'elevation_usage',
                component: ElevationUsage,
            },
            {
                path: 'elevation_oruxmaps',
                name: 'elevation_oruxmaps',
                component: ElevationOruxMaps,
            },
            {
                path: 'elevation_stats',
                name: 'elevation_stats',
                component: ElevationStats,
            },
        ],
    },
    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    },
    {
        path: '/privacy',
        name: 'privacy',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyPolicy.vue'),
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
